import { render } from "./DictionaryIcon.vue?vue&type=template&id=6f9ce0ae"
import script from "./DictionaryIcon.vue?vue&type=script&lang=js"
export * from "./DictionaryIcon.vue?vue&type=script&lang=js"

import exportComponent from "/builds/check-marq/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__